export default "./images/survio-2mczz-assets-reference-es.png";